import Button, { ColorButtonEnum } from "components/atoms/Button/Button";
import Input from "components/atoms/Input/Input";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import useVideoCallParticipants, { VideoCallParticipant } from "./useVideoCallParticipants";
import { Add, Error } from "@mui/icons-material";
import VideoCallParticipants from "../VideoCallParticipants/VideoCallParticipants";

type CreateVideoCallProps = {
  onInvitesSent?: (participants: VideoCallParticipant[]) => void;
}

const CreateVideoCall = ({ onInvitesSent }: CreateVideoCallProps): JSX.Element => {
  const { participants, addParticipant, removeParticipant } = useVideoCallParticipants();
  const [email, setEmail] = useState<string>('');
  const [isEmailOnError, setEmailOnError] = useState<boolean>(false);

  const onAddParticipant = (email: string): void => {
    if (!isEmailValid(email)) {
      setEmailOnError(true);
      return;
    }
    setEmailOnError(false);
    addParticipant(email);
    setEmail('');
  }

  const isEmailValid = (email: string): boolean => {
    const emailRegex = /^(?:([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?:(\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(?:([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
  }

  return  <div className='flex flex-col gap-2w w-[350px]'>
            <section id='list-participants'>
              <VideoCallParticipants participants={participants} removeParticipant={removeParticipant} />
            </section>

            <section id='add-participant' className='flex flex-col gap-1w'>
              <h2 className='text-subtitle1'><FormattedMessage id="videoCall.create.participantsAdd.title" /></h2>
              <div className='flex gap-1w'>
                <Input className='w-[250px]' onChange={setEmail} value={email} />
                <Button color={ColorButtonEnum.SECONDARY_ADMIN_BLUE} onClick={() => onAddParticipant(email)}>
                  <span className='flex justify-center items-center gap-1w'>
                    <Add fontSize="small" />
                    <FormattedMessage id="videoCall.create.participantsAdd.addButton" />
                  </span>
                </Button>
              </div>            
              {isEmailOnError && <span className="flex items-center gap-1w text-body2 text-main-rouge">
                <Error fontSize="small" />
                Veuillez saisir une adresse email
              </span>}
            </section>
            
            <section id='send-invite' className="flex w-full justify-center items-center">
              <Button color={ColorButtonEnum.SECONDARY_ADMIN_GREEN} onClick={() => onInvitesSent(participants)}>
                <FormattedMessage id="videoCall.create.participantsAdd.sendInviteButton" />
              </Button>
            </section>
          </div>
}

export default CreateVideoCall;